import { resolveEnquiryFormType } from "./enquiry-form-type";
import { parseMoreValue } from "./enquiry-more";
import { ENQUIRY_FORM_TYPE_LABELS, ENQUIRY_RESUME_BASE_URL, ENQUIRY_ROLE_LABELS } from "./enquiry-settings";

export type EnquiryMore = {
    formType?: string;
    category?: string;
    currentRole?: string;
    linkedin?: string;
    experience?: string;
    resume?: string;
};

export type EnquiryRow = {
    id?: number | string;
    timestamp?: string | number;
    name?: string;
    phoneno?: string;
    email?: string;
    location?: string;
    message?: string;
    ip?: string;
    browser?: string;
    category?: string;
    resume?: string;
    reversedip?: { city?: string; region?: string } | string | null;
    more?: EnquiryMore | string | null;
};

export const parseEnquiryMore = (row: EnquiryRow): EnquiryMore => parseMoreValue(row.more);

export const displayText = (value?: string | number | null) => {
    if (value == null || value === "") return "-";
    return String(value);
};

export { formatEnquiryDate, getEnquiryTimestampMs, parseEnquiryTimestamp } from "./enquiry-date";

export const displayFormType = (row: EnquiryRow) => {
    const formType = resolveEnquiryFormType(row);
    if (!formType) return "-";
    return ENQUIRY_FORM_TYPE_LABELS[formType] ?? formType;
};

export const displayCategory = (row: EnquiryRow) => {
    const more = parseEnquiryMore(row);
    return displayText(more.category ?? row.category);
};

export const displayCurrentRole = (row: EnquiryRow) => {
    const role = parseEnquiryMore(row).currentRole;
    if (!role) return "-";
    return ENQUIRY_ROLE_LABELS[role] ?? role;
};

export const displayIpLocation = (value: EnquiryRow["reversedip"]) => {
    if (value == null || value === "") return "-";
    if (typeof value === "string") return value;
    const city = value.city ?? "";
    const region = value.region ?? "";
    const label = [city, region].filter(Boolean).join(", ");
    return label || "-";
};

export const getResumePath = (row: EnquiryRow) => {
    const more = parseEnquiryMore(row);
    return more.resume ?? row.resume ?? "";
};

export const getResumeUrl = (path?: string) => {
    if (!path) return "";
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    return `${ENQUIRY_RESUME_BASE_URL}${path.replace(/^\//, "")}`;
};

export const getResumeLabel = (path?: string) => {
    if (!path) return "Resume";
    const parts = path.split("/");
    return parts[parts.length - 1] || "Resume";
};

export const getEnquiryId = (row: EnquiryRow): number | null | string => {
    const record = row as Record<string, unknown>;
    const id = record.id ?? record.ID;
    // if (typeof id === "number" && Number.isFinite(id)) return id;
    // if (typeof id === "string" && id.trim()) {
    //     const parsed = Number.parseInt(id, 10);
    //     return Number.isFinite(parsed) ? parsed : null;
    // }
    return id as string;
    // return null;
};

export const hasEnquiryResume = (row: EnquiryRow) => Boolean(getResumePath(row));

export const normalizeExternalUrl = (value?: string) => {
    if (!value?.trim()) return "";
    const trimmed = value.trim();
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    return `https://${trimmed.replace(/^\/+/, "")}`;
};
